import { ExternalLink } from "@/components/external-link";
import { externalUrls } from "@/constants/url";
import { Typography } from "@backpac/monica";

export function AuthDisclaimer() {
  return (
    <div className="flex flex-col items-center w-full justify-center text-center">
      <Typography asChild size="paragraphXs" color="textPrimary">
        <p>
          By using BackPac, you are agreeing to our
          <br />{" "}
          <ExternalLink to={externalUrls.TERMS_OF_SERVICE_URL} className="font-semibold underline">
            Terms of Service
          </ExternalLink>{" "}
          and{" "}
          <ExternalLink to={externalUrls.PRIVACY_POLICY_URL} className="font-semibold underline">
            Privacy Policy
          </ExternalLink>
        </p>
      </Typography>
    </div>
  );
}
